
import { Link } from "react-router-dom";
import { Button, ContactButton } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CtaSectionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink?: string;
  buttonVariant?: "default" | "outline" | "secondary" | "ghost" | "link" | "cta" | "subtle" | "destructive";
  bgColor?: "white" | "light" | "gradient" | "dark" | "purple";
  textColor?: "dark" | "white";
  useContactModal?: boolean;
  modalTitle?: string;
  modalDescription?: string;
  modalFormId?: string;
  additionalFields?: Record<string, any>;
}

export const CtaSection = ({
  title,
  description,
  buttonText,
  buttonLink = "/get-started",
  buttonVariant = "default",
  bgColor = "white",
  textColor = "dark",
  useContactModal = false,
  modalTitle,
  modalDescription,
  modalFormId,
  additionalFields = {}
}: CtaSectionProps) => {
  // Determine background colors
  let bgClasses = "bg-white";
  if (bgColor === "light") bgClasses = "bg-gray-50";
  else if (bgColor === "dark") bgClasses = "bg-gray-900";
  else if (bgColor === "purple") bgClasses = "bg-purple-900";
  else if (bgColor === "gradient") bgClasses = "bg-gradient-to-br from-edgefi-purple to-edgefi-amethyst";
  
  // Determine text colors
  let textClasses = "text-gray-900";
  let descriptionClasses = "text-gray-600";
  if (textColor === "white") {
    textClasses = "text-white";
    descriptionClasses = "text-white/90";
  }
  
  return (
    <section className={`${bgClasses} py-16 md:py-24`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${textClasses}`}>{title}</h2>
          <p className={`text-lg ${descriptionClasses} max-w-2xl mx-auto mb-8`}>{description}</p>
          
          {useContactModal ? (
            <ContactButton
              variant={buttonVariant}
              size="lg"
              className="shadow-md group"
              modalTitle={modalTitle || title}
              modalDescription={modalDescription || description}
              modalFormId={modalFormId}
              additionalFields={additionalFields}
            >
              {buttonText}
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </ContactButton>
          ) : (
            <Link to={buttonLink}>
              <Button 
                variant={buttonVariant} 
                size="lg"
                className="shadow-md group"
              >
                {buttonText}
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};
